export default __webpack_public_path__ + "static/What-we-do-asset-01-b43994e57eb5502ac47a0a5b6bd790a9.png";